import React, {Component} from 'react';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Icon from '@xo-union/tk-component-icons';
import {
  FavoriteToast,
  UnFavoriteToast,
} from '@tkww/ads-content-component-favorite-button/lib/components/FavoriteToast';
import {Wrapper as FavoriteButtonWrapper} from '@tkww/ads-content-component-favorite-button';
import {display} from '@tkww/ads-content-component-toast-banner';
import styles from './styles.css';

function PortalWrapper({children, container}) {
  return container ? ReactDOM.createPortal(children, container) : null;
}

export default class FavoriteImageButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      favorite: '',
      trackingData: {
        id: '',
        article_id: '',
        item_name: '',
        url: '',
        type: '',
        category_name: '',
        subcategory_name: '',
        content_strategy_type: '',
        tags: [],
      },
      portalNode: null,
    };
    this.portalRef = React.createRef();
  }

  componentDidMount() {
    const favoriteAttributes = this.getFavoriteAttributes();
    const trackingData = this.getTrackingData();

    setTimeout(() => this.waitForPortalNode(), 250);

    this.setState({
      favorite: favoriteAttributes,
      trackingData,
    });
  }

  waitForPortalNode = () => {
    const node = document.getElementById('custom-overlay-container');
    if (node) {
      this.setState({ portalNode: node });

    } else {
      this.timeout = setTimeout(this.waitForPortalNode, 100);
    }
  };

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  getFavoriteAttributes() {
    const {favorite_params, id} = this.props;

    const primaryEntityId = id;
    const favoriteParams = favorite_params;

    return {
      id: `${primaryEntityId}`,
      ...favoriteParams,
      favorite_params: {
        ...favoriteParams
      },
    };
  }

  handleSourceValue(source) {
    try {
      if (source !== 'TK_PLACEHOLDRE_PAGE_TYPE') return source;

      const metadata = window.XO.metadata.page_data;

      return metadata.results_terms.terms
        ? 'filtered results page'
        : 'unfiltered results page';
    } catch (error) {
      return source;
    }
  }

  getTrackingData() {
    const {trackingData} = this.props;

    if (!trackingData) return trackingData;

    return {
      ...trackingData,
      source: this.handleSourceValue(trackingData.source),
    };
  }

  static handleClickCallback() {
    const contentHeaderNav = document.querySelector('#content-header-nav');
    if (contentHeaderNav) {
      contentHeaderNav.style.zIndex = '0';
    }

    const stickyHeader = document.querySelector(
      '.bride-social-buttons.text-center.sticky.sticky-top',
    );

    if (stickyHeader) {
      stickyHeader.style.zIndex = '1';
    }
  }

  static handleCloseCallback() {
    const contentHeaderNav = document.querySelector('#content-header-nav');
    if (contentHeaderNav) {
      contentHeaderNav.style.zIndex = '2';
    }

    const stickyHeader = document.querySelector(
      '.bride-social-buttons.text-center.sticky.sticky-top',
    );
    if (stickyHeader) {
      stickyHeader.style.zIndex = '2';
    }
  }

  render() {
    const {favorite, trackingData, portalNode} = this.state;
    const {
      favoriteIcon,
      favoriteFilledIcon,
      iconSize,
      store,
      inStickyHeader,
      portalButton,
      id,
      portalSticky,
    } = this.props;

    if (!favorite.object || !favorite.id) return null;

    const containerStyles = inStickyHeader
      ? styles['sticky-favorite-image-container']
      : styles['favorite-image-container'];
    const actionLink = inStickyHeader
      ? styles['sticky-action-link-variant']
      : styles['action-link-variant'];

    if (portalButton && document.getElementById(id)) {
      return (
        <PortalWrapper container={document.getElementById(id)}>
          <div>
            <FavoriteButtonWrapper
              portalNode={portalNode}
              className={`${styles['action-link']} ${actionLink}`}
              enhancedStore={store}
              favoriteParams={favorite.favorite_params}
              filledIcon={<Icon name={favoriteFilledIcon} size={iconSize} />}
              icon={<Icon name={favoriteIcon} size={iconSize} />}
              successFavoriteCb={() =>
                display({
                  data: (
                    <FavoriteToast env={process.env.UNION_DEPLOYMENT_ENV} />
                  ),
                  dismissTimeout: 5000,
                })
              }
              successUnFavoriteCb={() =>
                display({
                  data: (
                    <UnFavoriteToast env={process.env.UNION_DEPLOYMENT_ENV} />
                  ),
                  dismissTimeout: 5000,
                })
              }
              trackParams={trackingData}
              handleClickCallback={FavoriteImageButton.handleClickCallback}
              handleCloseCallback={FavoriteImageButton.handleCloseCallback}
              metadata={{
                applicationName: 'real-weddings',
                userAction: 'attempted to favorite',
              }}
            />
          </div>
        </PortalWrapper>
      );
    }

    return (
      <>
        <div className={containerStyles}>
          <FavoriteButtonWrapper
            portalNode={portalNode}
            className={`${styles['action-link']} ${actionLink}`}
            enhancedStore={store}
            favoriteParams={favorite.favorite_params}
            filledIcon={<Icon name={favoriteFilledIcon} size={iconSize} />}
            icon={<Icon name={favoriteIcon} size={iconSize} />}
            successFavoriteCb={() =>
              display({
                data: <FavoriteToast env={process.env.UNION_DEPLOYMENT_ENV} />,
                dismissTimeout: 5000,
              })
            }
            successUnFavoriteCb={() =>
              display({
                data: (
                  <UnFavoriteToast env={process.env.UNION_DEPLOYMENT_ENV} />
                ),
                dismissTimeout: 5000,
              })
            }
            trackParams={trackingData}
            handleClickCallback={FavoriteImageButton.handleClickCallback}
            handleCloseCallback={FavoriteImageButton.handleCloseCallback}
            metadata={{
              applicationName: 'real-weddings',
              userAction: 'attempted to favorite',
            }}
          />
        </div>

        {portalSticky ? (
          <PortalWrapper container={document.getElementById(id)}>
            <div className={styles['sticky-favorite-image-container']}>
              <FavoriteButtonWrapper
                portalNode={portalNode}
                className={`${styles['action-link']} ${styles['sticky-action-link-variant']}`}
                enhancedStore={store}
                favoriteParams={favorite.favorite_params}
                filledIcon={<Icon name={favoriteFilledIcon} size={iconSize} />}
                icon={<Icon name={favoriteIcon} size={iconSize} />}
                successFavoriteCb={() =>
                  display({
                    data: (
                      <FavoriteToast env={process.env.UNION_DEPLOYMENT_ENV} />
                    ),
                    dismissTimeout: 5000,
                  })
                }
                successUnFavoriteCb={() =>
                  display({
                    data: (
                      <UnFavoriteToast env={process.env.UNION_DEPLOYMENT_ENV} />
                    ),
                    dismissTimeout: 5000,
                  })
                }
                trackParams={trackingData}
                handleClickCallback={FavoriteImageButton.handleClickCallback}
                handleCloseCallback={FavoriteImageButton.handleCloseCallback}
                metadata={{
                  applicationName: 'real-weddings',
                  userAction: 'attempted to favorite',
                }}
              />
            </div>
          </PortalWrapper>
        ) : null}
      </>
    );
  }
}

FavoriteImageButton.defaultProps = {
  iconSize: 'sm',
  favoriteIcon: 'heart',
  favoriteFilledIcon: 'heart_filled',
};

FavoriteImageButton.propTypes = {
  favoriteFilledIcon: PropTypes.string,
  favoriteIcon: PropTypes.string,
  iconSize: PropTypes.string,
  store: PropTypes.objectOf(PropTypes.any).isRequired,
};
